export default "/profile/images/KeepinCRM.svg?2ee144b37c246157294f79ec2ff9dbfc";